import LoadingAnimation from "@assets/svg/LoadingAnimation";
import CustomFormInput from "@components/CustomFormInput/CustomFormInput";
import { Button } from "@components/ui/button";
import { updateUserProfile } from "@endpoints/auth.service";
import { setUserData } from "@store/actions/auth.action";
import { RootState } from "@store/reducers";
import { IndustryType } from "@utils/constants";
import { colors } from "@utils/theme";
import { useSnackbar } from "notistack";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CreateBasicProfileContext } from "../CreateBasicProfilePageLayout";

const Step3 = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useSelector((state: RootState) => state.auth);

  const { setActiveStep, setPreviewData } = useContext(CreateBasicProfileContext)!;
  const [isLoading, setIsLoading] = useState(false)
  const { handleSubmit, register, watch } = useForm({
    defaultValues: {
      jobTitle: user?.jobTitle,
      location: user?.location,
      industryType: typeof user?.industryType === 'string' ? user?.industryType : null
    },
  });

  useEffect(() => {
    const sub = watch((values) => {
      setPreviewData((prev) => ({
        ...prev,
        jobTitle: values.jobTitle,
        location: values.location,
        industryType: values.industryType ?? undefined,
      }));
    });
    return () => sub.unsubscribe();
  }, [watch, setPreviewData]);

  const onSubmit = handleSubmit(async (formData) => {
    try {
      setIsLoading(true);
      const { success, data } = await updateUserProfile({
        ...formData,
        isBasicProfileCompleted:true
      });
      if (success) {
        dispatch(setUserData(data));
        navigate('/create-profile')
        // setSteps((prev) =>
        //   prev.map((step, i) => (i === 0 ? { ...step, isCompleted: true } : step)),
        // );
        // setActiveStep((prev) => prev + 1);
      }
    } catch (error: any) {
      enqueueSnackbar(error?.message || "Unable to save details.", {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  });


  return (
    <div className="flex flex-col bg-white rounded-md p-5 min-h-96 w-[40%] h-max">
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-1">
          <span className="font-bold text-primary">Career details</span>
          <span className="text-sm text-light-black">
            Add your basic career details.
          </span>
        </div>
        <span className="rounded-full font-semibold text-xss text-blue-600 bg-blue-50 px-2 py-0.5">
          Step 3
        </span>
      </div>
      {/* Form container */}
      <div className="flex flex-col w-full mt-5 gap-3">
        <CustomFormInput
          label="Industry"
          type="dropdown"
          register={register("industryType")}
          placeholder="Select industry type"
          dropdownList={Object.values(IndustryType).map((value) => ({
            label: value,
            value,
          }))}
        />
        <CustomFormInput
          label="Current job title"
          register={register("jobTitle")}
          placeholder="Enter you job title"
        />
        <CustomFormInput
          label="Location"
          register={register("location")}
          placeholder="Enter your location"
        />
      </div>
      <div className="flex items-center gap-2 w-full mt-4">
        <button
          onClick={() => setActiveStep((prev) => prev - 1)}
          className="rounded-md bg-white border text-primary border-primary h-9 px-3 font-semibold text-xs hover:bg-light-white-400"
        >
          Back
        </button>
        <Button
          variant="secondary"
          className="flex-1"
          disabled={isLoading}
          onClick={onSubmit}
        >
          {isLoading && <LoadingAnimation color={colors.White} />}
          Generate my basic profile
        </Button>
      </div>
    </div>
  );
};

export default Step3;
